@if (!isLoading && isRequired) {
<div class="form-group">
  <label class="control-label">New Page Url</label>
  @if (isReadOnly) {
  <div>
    <a [attr.href]="customerUrl + pageUrlControl.value" target="_blank" name="url" rel="noreferrer">{{ customerUrl + pageUrlControl.value }}</a>
  </div>
  } @else {
  <div class="input-group">
    <span class="input-group-text">{{ customerUrl }}</span>
    <input type="text"  class="form-control" [formControl]="pageUrlControl" [formValidation]="pageUrlControl" [readOnly]="isReadOnly" />
  </div>
  }
</div>
}